export default {
  'order.tab.require_allocate_stock': '待分配庫存',
  'order.tab.require_allocate_stock_tooltips': '待分配庫存',
  'order.tab.allocated_stock': '已分配庫存',
  'order.tab.allocated_stock_tooltips': '已分配庫存',
  'order.tab.interface_pack_stock': '已打包（回饋）',
  'order.tab.interface_cancel_stock': '異常/取消（回饋）',
  'order.tab.require_ship_stock': '待發貨',
  'order.tab.cancelled_by_platform': '平台已取消',
  'interface.order.request_name': 'External WMS Status',
  'fulfillment.order.allocate_stock_error': '分配 - 庫存错误',
  'fulfillment.order.allocate_stock_status': '分配 - 庫存狀態',
  'fulfillment.order.shipped_stock_error': '發貨 - 庫存錯誤',
  'fulfillment.order.shipped_stock_status': '發貨 - 庫存狀態',
  'fulfillment.action-msg.allocate-stock-success': 'Allocated OMS Stock Success',
  'fulfillment.action-msg.pack-stock-success': 'Packed OMS Stock Success',
  'fulfillment.action-msg.cancel-stock-success': 'Cancel Stock Success',
  'fulfillment.action-msg.send-to-sap-success': 'Send To SAP Success',
};
